import analytics from 'yoda-core-components/lib/helpers/Analytics/Analytics';
import { logwebvitals } from 'yoda-site-components/lib/middlewares/WebvitalsMiddleware';
import get from 'lodash/get';
import * as MyOrdersActionTypes from '../actionTypes/MyOrdersActionTypes';
import * as CurbsideActionTypes from '../actionTypes/CurbsideActionTypes';
import OrderActionFilter from '../analytics/OrderActionFilter';

const orderActionFilter = new OrderActionFilter();

/**
 * This function will used only for redux middleware only to track tagging based on action request
 */
const PostPurchaseAnalyticsMiddleware = store => next => action => { // eslint-disable-line
    if (!__SERVER__) {
        let digitalData = null;
        let analyticsEventName = null;
        const errorMes = 'error';

        /**
         * component can trigger an action only for tagging
         * action should contain analytics object as mandatory
         * @param analytics.type - {string}  - tagging key
         * @param analytics.JCPDL - {Object}  - required additional details for tagging event
         */
        try {
            switch (action.type) {
                case MyOrdersActionTypes.PAGE_LOAD_ANALYTICS_ACTION:
                    // console.log('********* CkMiddleware ORDER_PAGE_ANALYTICS_ACTION ***********');
                    digitalData = orderActionFilter.getOrderPageDL(store, action.payload);
                    digitalData = orderActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = 'digitalDataReady';
                    logwebvitals(store, digitalData);
                    break;
                case CurbsideActionTypes.CURBSIDE_PICKUP_LOAD_ANALYTICS_ACTION:
                    digitalData = orderActionFilter.getCurbsidePickupAnalyticsAction(
                        store,
                        action.payload
                    );
                    digitalData = orderActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = 'digitalDataReady';
                    break;
                case CurbsideActionTypes.CURBSIDE_EVENTS_ANALYTICS_ACTION:
                    digitalData = get(action, 'data', '');
                    analyticsEventName = get(action, 'eventName', '');
                    break;
                case CurbsideActionTypes.CURBSIDE_STATUS_INFO_ACTION:
                    digitalData = orderActionFilter.getCurbsideStatusPageDetails(
                        store,
                        action.payload
                    );
                    digitalData = orderActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = 'digitalDataReady';
                    break;
                case MyOrdersActionTypes.RETURNS_ANALYTICS_ACTION:
                    digitalData = orderActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = get(action, 'eventName', '');
                    break;
                case 'Error':
                    throw errorMes;
                default:
                    break;
            }
            if (analyticsEventName || digitalData) {
                /* eslint-disable no-console */
                console.info('digitalData -', digitalData);
                // console.log('********** Just before firing TRACK **********');
                digitalData.dataVersion = 1;
                analytics.track(analyticsEventName, digitalData);
            }
        } catch (error) {
            /* eslint-disable no-console */
            console.log(error);
        }
    }
    if (action.type) {
        return next(action);
    }
};
export default PostPurchaseAnalyticsMiddleware;
